import React, { Component, createRef } from 'react';

class Marquee extends Component {
  constructor(props) {
    super(props);
    this.containerRef = createRef();
    this.state = {
      isVisible: false,
    };
  }

  static defaultProps = {
    speed: 30,
    direction: 'left',
    spacing: 40,
  };

  componentDidMount() {
    this.setState({ isVisible: true });
  }

  render() {
    const { images, speed, direction, spacing } = this.props;
    const { isVisible } = this.state;

    return (
      <div className="marquee-container" ref={this.containerRef}>
        {isVisible && (
          <div
            className={`marquee-content ${direction === 'left' ? 'to-left' : 'to-right'}`}
            style={{
              animationDuration: `${speed}s`,
              ['--logo-spacing']: `${spacing}px`,
            }}
          >
            {/* {images.map((logo, index) => (
              <div
                key={`img-${index}`}
                className="marquee-item"
                style={{ padding: `0 ${spacing / 2}px` }}
              >
                <img src={logo.img} alt={logo.alt} />
              </div>
            ))}
            {images.map((logo, index) => (
              <div
                key={`img-dup-${index}`}
                className="marquee-item"
                style={{ padding: `0 ${spacing / 2}px` }}
              >
                <img src={logo.img} alt={logo.alt} />
              </div>
            ))} */}
            {[...images, ...images, ...images].map((logo, index) => (
              <div
                key={`img-${index}`}
                className="marquee-item"
                style={{ padding: `0 ${spacing / 2}px` }}
              >
                <img src={logo.img} alt={logo.alt} />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Marquee;
